/**
 * The one rule for a value the source does not hold (SIH-17 I-8b, BA-approved copy, N4/N10).
 *
 * A value the source holds is shown verbatim and never reshaped (BR-1). A value it does not hold -
 * null or the empty string - reads "Not recorded by the source", on any status and on every surface
 * that shows the field (the failed table and cards, the pending table and cards, and the invoice
 * detail). Kept apart from the card and table components so both can import it without a cycle.
 */

export const NOT_RECORDED_TEXT = 'Not recorded by the source'

/** A value the source holds, verbatim; null and the empty string both mean none is held. */
export function heldValue(value: string | null): string | null {
  // null passes straight through as null; only the empty string needs mapping, so there is one test and no redundant half.
  return value === '' ? null : value
}
